module.exports = __webpack_public_path__ + "static/strength_plans-b341abc730cd4f06c45bc2422283748a.jpg";